import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Ferry Search Service
 * Otobüs arama API'leri için servis
 */
export const ferrySearchService = {
  /**
   * Otobüs otomatik tamamlama önerilerini getir
   * @param {string} term - Arama terimi (örn: "Ad")
   * @param {string} languageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   */
  ferryOriginSearch: ({
    term = "",
    languageCode = "tr",
    headers = {},
    hasErrorHandler = false,
  }) => {
    const queryParams = new URLSearchParams({
      term: term,
      languageCode: languageCode,
    });

    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.search.originSearch}?${queryParams.toString()}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },
  ferryDestinationSearch: ({
    term = "",
    originSlug = "",
    languageCode = "tr",
    headers = {},
    hasErrorHandler = false,
  }) => {
    const queryParams = new URLSearchParams({
      term: term,
      languageCode: languageCode,
      originSlug: originSlug,
    });
    if (!originSlug) {
      console.error("originSlug is required");
    }
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.search.destinationSearch}?${queryParams.toString()}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },
  ferryPopularOrigins: ({
    languageCode = "tr",
    headers = {},
    hasErrorHandler = false,
  }) => {
    const queryParams = new URLSearchParams({
      languageCode: languageCode,
    });

    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.search.popularOrigins}?${queryParams.toString()}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },
  getFerryVehicles: ({
    originSlug = "",
    destinationSlug = "",
    languageCode = "tr",
    headers = {},
    hasErrorHandler = false,
  }) => {
    const queryParams = new URLSearchParams({
      languageCode: languageCode,
      originSlug: originSlug,
      destinationSlug: destinationSlug,
    });
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.search.getVehicles}?${queryParams.toString()}`,
      headers,
      hasErrorHandler,
    });
  },
  searchResults: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.search.searchResults,
      payload,
      headers,
      hasErrorHandler,
    });
  },
  getOriginAndDestination: (
    payload = {},
    languageCode = "tr",
    headers = {},
    hasErrorHandler = false,
  ) => {
    const queryParams = new URLSearchParams({
      languageCode: languageCode,
      slug: payload.slug,
      vehicleId: payload.vehicleId,
    });
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.search.getOriginAndDestination}?${queryParams.toString()}`,
      headers,
      hasErrorHandler,
    });
  },

  allocate: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.search.allocate,
      payload,
      headers,
      hasErrorHandler,
    });
  },

  allocateCouponSale: (payload = {}, headers = {}, hasErrorHandler = false) => {
    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.search.allocateCouponSale,
      payload,
      headers,
      hasErrorHandler,
    });
  },
};
